// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._11c8nbxd{font:var(--ds-font-heading-small,normal 600 1pc/20px ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}\n._18u0idpf{margin-left:0}\n._19pkidpf{margin-top:0}\n._2hwxidpf{margin-right:0}\n._otyridpf{margin-bottom:0}\n._syazazsu{color:var(--ds-text-subtle,#505258)}", ""]);
// Exports
module.exports = exports;
